import styled from "styled-components";

import { device } from "../../services";
import { WrapperContainer } from "../../components";

export const ParagraphWrapper = styled(WrapperContainer)`
  @media screen and ${device.tablet} {
    margin-top: 22px !important;
  }
`;
